import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription, merge, debounceTime, distinctUntilChanged, filter, switchMap, catchError, of, map, BehaviorSubject, Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatSort } from '@angular/material/sort';
import { ExpressionOfInterest } from '../../../../../shared/models/ExpressionOfInterest';
import saveAs from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-eoi-list',
  templateUrl: './eoi-list.component.html',
  styleUrl: './eoi-list.component.css'
})
export class EoiListComponent {
  [x: string]: any;
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  userType = sessionStorage.getItem('UserType');

  dataSource!: MatTableDataSource<ExpressionOfInterest>
  displayedColumns: string[] = ['RowNum', 'EnterpriseCode', 'EnterpriseName', 'UdyamRegistrationNumber', 'DateOfEstablishment', 'CreatedOn', 'Sector', 'Gender', 'District', 'EnterpriseType', 'SocialCategory', 'NoofEmployees', 'TurnoverFY2024_25', 'downloadAll', 'responseDoc']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchText: string = '';
  frmEOIList: FormGroup;
  LoadGrading: any[] = [];
  allrecord: any[] = [];

  totalItems: number = 0; // Example total items

  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  length: number = 0;
  pageSize: number = 10;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  loadingSequence: boolean = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  term$ = new BehaviorSubject<string>('');


  constructor(private ngxUiLoaderService: NgxUiLoaderService, private sanitizer: DomSanitizer, private dialog: MatDialog, private formBuilder: FormBuilder, private apiService: ApiService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private commonService: CommonService, private toastrService: ToastrService) {
    this.frmEOIList = this.formBuilder.group({
      fromDate: [''],
      toDate: [''],
      searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])
    });
  }

  DtoPagination = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "FromDate": "",
    "ToDate": ""
  }


  ngOnInit(): void {
    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SortColumn = "CreatedOn";
    this.DtoPagination.SortDirection = "DESC";
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = "";
    this.DtoPagination.FromDate = "";
    this.DtoPagination.ToDate = "";
    this.loadingSequence = true; // ⬅️ Start loader before anything begins

    this.LoadEOIRecord();

  }

  ngAfterViewInit() {
    if (!this?.sort) {
      //console.error("MatSort is not initialized!");
      return;
    }
    this.LoadEOIRecord();
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.frmEOIList.reset();
    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SortColumn = "CreatedOn";
    this.DtoPagination.SortDirection = "DESC";
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = "";
    this.DtoPagination.FromDate = "";
    this.DtoPagination.ToDate = "";
    this.LoadEOIRecord();
  }

  LoadEOIRecord() {
    const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
    const toDateRaw = this.frmEOIList.get('toDate')?.value;

    let fromDate = '';
    let toDate = '';

    if (fromDateRaw) {
      const d = new Date(fromDateRaw);
      fromDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    if (toDateRaw) {
      const d = new Date(toDateRaw);
      toDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    this.loadDataSubscription.unsubscribe();

    if (!this?.sort) {
      //console.error("Error: MatSort is undefined");
      return;
    }
    this.sort?.sortChange.subscribe(() => this.pagination.pageIndex = 0);
    this.loadDataSubscription = merge(
      this.sort?.sortChange,
      this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort?.active;
          this.DtoPagination.SortDirection = this.sort?.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;
          this.DtoPagination.FromDate = fromDate;
          this.DtoPagination.ToDate = toDate;


          return this.apiService.getRequest(API_ENDPOINTS.EOI.GETEoi, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp.status) {
            //debugger;
            this.length = resp.totalRecords;
          }
          console.log(resp.data);
          return resp.data;
        })
      ).subscribe(data => {
        this.dataSource = data;
        this.allrecord = data;
        this.adjustPaginator();
      });

  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }


  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadEOIRecord();
  }



  onSearchClick(searchValue: string): void {
    const searchControl = this.frmEOIList.get('searchControl');
    const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
    const toDateRaw = this.frmEOIList.get('toDate')?.value;

    let fromDate = '';
    let toDate = '';

    if (fromDateRaw) {
      const d = new Date(fromDateRaw);
      fromDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    if (toDateRaw) {
      const d = new Date(toDateRaw);
      toDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    if ((searchControl?.value && searchValue.trim() !== '') || (fromDate != '' && toDate != '')) {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.LoadEOIRecord();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }

  //#region My exportToPDF
  exportToPDF(): void {
    this.loadingSequence = true;
    // Initialize jsPDF in landscape mode
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    // Define table columns
    const columns = [
      'Sr.No',
      'Enterprise Code',
      'Enterprise Name',
      'Udyam Registration Number',
      'Date of Establishment',
      'Submission Date',
      'Sector',
      'Gender',
      'District',
      'Enterprise Type',
      'Social Category',
      'No Of Employees',
      'Turnover Financial Year 2024_25'
    ];

    // Prepare table rows
    const rows = this.allrecord.map((item, index) => [
      item.RowNum, // Sr. No
      item.EnterpriseCode,
      item.EnterpriseName,
      item.UdyamRegistrationNumber,
      item.DateOfEstablishment,
      item.CreatedOn,
      item.Sector,
      item.Gender,
      item.District,
      item.EnterpriseType,
      item.SocialCategory,
      item.NumberOfEmployees,
      item.TurnoverFY2024_25
    ]);

    // Add a title to the PDF
    doc.text('EOF Report', 14, 15);

    // Generate the table using autoTable
    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 25, // Start the table below the title
      theme: 'striped',
      headStyles: { fillColor: [22, 160, 133] },
      styles: { fontSize: 6, cellWidth: 'auto' },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 20 },
      columnStyles: {
        0: { cellWidth: 10 }, // Sr. No
        1: { cellWidth: 25 }, // EnterpriseCode
        2: { cellWidth: 40 }, // EnterpriseName
        3: { cellWidth: 30 }, // UdyamRegistrationNumber
        4: { cellWidth: 20 }, // Submi        ssionDate
        5: { cellWidth: 20 }, // Submi        ssionDate
        6: { cellWidth: 20 }, // Sector
        7: { cellWidth: 15 }, // Gender
        8: { cellWidth: 30 }, // District
        9: { cellWidth: 20 }, // Enterprise Type
        10: { cellWidth: 20 },// Social Category
        11: { cellWidth: 20 },// No Of Employees
        12: { cellWidth: 15 } // TurnoverFinancial Year2024_25
      },
    });
    // Save the PDF file
    doc.save('EOI.pdf');
    this.loadingSequence = false;
  }
  //#endregion

  //#region My exportToExcel

  // ✅ helper to parse dates safely
  parseDate(value: any): Date | null {
    if (!value) return null;

    // If it's already a Date object
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }

    // Try direct parse
    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) {
      return parsed;
    }

    // Try dd-MM-yyyy or dd/MM/yyyy
    const parts = String(value).split(/[-/]/);
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      if (year && month && day) {
        return new Date(year, month - 1, day);
      }
    }

    return null;
  }

  exportToExcel(): void {
    this.loadingSequence = true;
    const fileName = 'EOI_List.xlsx';

    // ✅ Prepare export data
    const excelData = this.allrecord.map((item: any) => ({
      'Sr.No': item.RowNum,
      'Enterprise Code': item.EnterpriseCode,
      'Enterprise Name': item.EnterpriseName,
      'Udyam Registration Number': item.UdyamRegistrationNumber,
      'Date of Establishment': this.parseDate(item.DateOfEstablishment),
      'Submission Date': this.parseDate(item.CreatedOn),
      'Sector': item.Sector,
      'Gender': item.Gender,
      'District': item.District,
      'Enterprise Type': item.EnterpriseType,
      'Social Category': item.SocialCategory,
      'Number Of Employees': item.NumberOfEmployees,
      'Turnover Financial Year 2024_25': item.TurnoverFY2024_25
    }));

    // ✅ Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // ✅ Loop through each cell and set date type + format
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) { // skip header row
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellAddress];

        if (cell && cell.v instanceof Date) {
          cell.t = 'd';              // Excel date type
          cell.z = 'dd-mm-yyyy';     // Excel format
        }
      }
    }

    // ✅ Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Expression Of Interest': worksheet },
      SheetNames: ['Expression Of Interest'],
    };

    // ✅ Write file
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveExcelFile(excelBuffer, fileName);
    this.loadingSequence = false;
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }



  //exportToExcel(): void {
  //  this.loadingSequence = true;
  //  // Define the file name
  //  const fileName = 'EOI_List.xlsx';
  //  // Prepare the data for export
  //  const excelData = this.allrecord.map((item, index) => ({
  //    'Sr.No': item.RowNum,
  //    'Enterprise Code': item.EnterpriseCode,
  //    'Enterprise Name': item.EnterpriseName,
  //    'Udyam Registration Number': item.UdyamRegistrationNumber,
  //    'Date of Establishment': item.DateOfEstablishment,
  //    'Submission Date': item.CreatedOn,
  //    'Sector': item.Sector,
  //    'Gender': item.Gender,
  //    'District': item.District,
  //    'Enterprise Type': item.EnterpriseType,
  //    'Social Category': item.SocialCategory,
  //    'Number Of Employees': item.NumberOfEmployees,
  //    'Turnover Financial Year 2024_25': item.TurnoverFY2024_25
  //  }));

  //  // Create a worksheet from the data
  //  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

  //  // Create a workbook and append the worksheet
  //  const workbook: XLSX.WorkBook = {
  //    Sheets: { 'Expression Of Interest': worksheet },
  //    SheetNames: ['Expression Of Interest'],
  //  };

  //  // Generate a buffer for the Excel file
  //  const excelBuffer: any = XLSX.write(workbook, {
  //    bookType: 'xlsx',
  //    type: 'array',
  //  });
  //  // Save the Excel file
  //  this.saveExcelFile(excelBuffer, fileName);
  //  this.loadingSequence = false;
  //}
  //saveExcelFile(buffer: any, fileName: string): void {
  //  const data: Blob = new Blob([buffer], {
  //    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  //  });
  //  saveAs(data, fileName);
  //}


  private getValidDate(dateString: string | undefined): Date | null {
    // Check if the date string is defined and not an empty string.
    if (dateString && dateString.trim() !== '') {
      const date = new Date(dateString);
      // Use a simple check to see if the date is valid.
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    return null;
  }


  //#endregion

  action(EnterpriseUniqueId: string, action: string): void {
    // Implement approval logic here
    this.router.navigate(['/eoi-view', EnterpriseUniqueId, action]);
  }

  onDownload(filePath: string, fileName: string) {
    this.loadingSequence = true; // ⬅️ Start loader before anything begins
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.loadingSequence = false; // ⬅️ close loader before anything begins
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
}
